import UNIT_TYPES from "../units";

export const DWARVES_MELEE_COMBAT_BONUS_ADJACENT_TO_MOUNTAIN = 2;

export const MINE_EXPLORATION = 'mine_exploration'

export const MINE_EXPLORATION_CONFIG = {
  id: MINE_EXPLORATION,
  label: 'Разведка рудника',
  image: '/img/icons/mine_exploration.9e85865b.png',
  priceCoins: 3,
}

export const DWARVES_RESTRICTED_UNIT_TYPES = [UNIT_TYPES.D8.id, UNIT_TYPES.D12.id];